import {Dispatch, SetStateAction} from 'react'

export interface PaginationInterface {
    itemsPerPage: number;
    totalItems: number;
    setCurrentPage: Dispatch<SetStateAction<number>>;
    setItemsPerPage: Dispatch<SetStateAction<number>>;
}

export enum ActionType {
    INCREMENT = "INCREMENT",
    DECREMENT = "DECREMENT",
    SET = 'SET',
}

export interface SetAction {
    type: ActionType.SET;
    payload: number;
}


export type Action = | {type: ActionType.DECREMENT} | {type: ActionType.INCREMENT} | SetAction

export type State = {
    counter: number;
}

type PropsPagination<T> = {
    currentPage: number
    itemsPerPage: number
    data: T[]
}

export const initialState: State = {
    counter: 1,
}

export function paginateReducer(state: State, action: Action) {

    switch (action.type) {
        case ActionType.INCREMENT:
            return {counter: state.counter + 1}
        case ActionType.DECREMENT:
            return {counter: state.counter - 1}
        case ActionType.SET:
            return {counter: action.payload}
        default:
            throw new Error('Unknown action')
    }
}

export function paginate<T>({currentPage, itemsPerPage, data}: PropsPagination<T>): T[] {

    const startIndex = (currentPage - 1) * itemsPerPage;
    return data.slice(startIndex, startIndex + itemsPerPage);
}